module.exports = __webpack_public_path__ + "img/5-2.55a90b0c.svg";